import React from 'react';
import { PaystackConsumer } from 'react-paystack';
import CustomButton from '../Button/CustomButton';
import { strings } from '../../constants';
import AddIcon from '../CustomSVGIcons/AddIcon';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { useDispatch } from 'react-redux';
import { addPaymentMethod } from '../../redux/payment/action';

interface IPayButton {
    email: string;
    amount: number; // in kobo
    isAddNewCardButton?: boolean;
    publicKey: string;
}

const PayStack: React.FC<IPayButton> = ({ email, amount, publicKey, isAddNewCardButton }) => {
    const { themeStyle } = useThemeContext();
    const dispatch = useDispatch();
    const onSuccess = (data?: any) => {
        // Handle successful payment

        /** The Non US Flag will force this to be used for Paystack only */
        dispatch(addPaymentMethod({ ...data, isNonUs: true })); //TODO: Type this proerly so that it shows a different data for paystack and stripe
        if (isAddNewCardButton) {
            /** Use For one time charge */
        }
    };
    const onClose = (data?: any) => {
        // Handle closure of payment modal
    };

    const config = {
        reference: new Date().getTime().toString(),
        email: email,
        amount: amount, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
        publicKey,
    };

    const componentProps = {
        ...config,
        onSuccess,
        onClose,
    };

    return (
        <PaystackConsumer {...componentProps}>
            {({ initializePayment }) => (
                <CustomButton
                    label={strings.add_new_card}
                    onClick={() => initializePayment(onSuccess, onClose)}
                    withIcon
                    customIcon={
                        <AddIcon
                            style={{ marginLeft: '4px' }}
                            height={'20px'}
                            width={'20px'}
                            fill={theme[themeStyle].zeus_dark}
                        />
                    }
                />
            )}
        </PaystackConsumer>
    );
};

export { PayStack };
